// extracted by mini-css-extract-plugin
module.exports = {"label":"_f8db869"};